// extracted by mini-css-extract-plugin
export default {"textContainer":"productEngineeringCaseStudy_textContainer__JmPvl","overlay":"productEngineeringCaseStudy_overlay__U4vR8","heading":"productEngineeringCaseStudy_heading__TpK+6"};